
    <div class="container">
      <div class="mat-title">{{ data.title | translate | titlecase }}</div>

      <ng-container *ngIf="(logs$ | async) as logs">
        <div class="mat-subheading-2 container__subtitle">
          <span *ngIf="logs.length === 0; else warningMessage">
            {{ data.message | translate | sentancecase }}
          </span>
          <ng-template #warningMessage>
            {{ 'warning-running-logs' | translate | sentancecase }}
          </ng-template>
        </div>
      </ng-container>

      <div
        *ngIf="loading"
        fxLayout
        fxLayoutAlign="center center"
        class="padding-16"
      >
        <mat-spinner diameter="48"></mat-spinner>
      </div>

      <ml-dialog-actions
        [buttonRight]="'confirm'"
        [disable]="loading"
        (clickLeft)="onClose()"
        (clickRight)="onConfirm()"
      ></ml-dialog-actions>
    </div>
  